import AdvancedController from "./advanced-controller"
import gsap from 'gsap';
import { debounce } from './debounce'
import { Breakpoints } from './breakpoints';

const VIDEO_PAUSE_BUTTON_DEBOUNCE = 1500

export default class KeyvisualController extends AdvancedController {

  static targets = [
    "wrapper",
    "video",
    "info",
    "videoPlay",
    "videoPoster"
  ]

  static values = {
    infoVisible: Boolean,
    inTransition: Boolean,
    video: Object,
    hasVideo: Boolean,
    isVideoPlaying: {
      default: false,
      type: Boolean
    }
  }

  connect() {
    super.connect();
    this._mouseMoveDebounced = debounce(this._mouseMoveDebounced.bind(this), VIDEO_PAUSE_BUTTON_DEBOUNCE)

    this.breakpoints = new Breakpoints();
    if (this.breakpoints.breakpointUp('lg')) {
      if (this.videoValue.url_1080p && this.videoValue.url_1080p !== "")
        this.videoTarget.setAttribute("src", this.videoValue.url_1080p);
    }

    // this.videoTarget.addEventListener('play', this.onPlay.bind(this));
    if (this.hasVideoTarget) {
      this.videoTarget.addEventListener('pause', this.onPause.bind(this));
    }
  }

  onToggleInformation() {
    if (this.inTransitionValue) return;
    this.infoVisibleValue = !this.infoVisibleValue
    this._handleInfoState();
  }

  onMouseMove() {
    if (this.isVideoPlayingValue && !this.infoVisibleValue) {
      this._showPlayPause();
    }
    this._mouseMoveDebounced();
  }

  onVideoToggle() {
    this.isVideoPlayingValue = !this.isVideoPlayingValue;
    this.isVideoPlayingValue ? this._startVideo() : this._stopVideo();
  }

  onPlayEnter() {
    if (this.isVideoPlayingValue) {
      this._showPlayPause();
    }
  }

  onPlayLeave() {
    if (this.isVideoPlayingValue) {
      this._hidePlayPause();
    }
  }

  onFullscreen() {
    const elem = this.videoTarget;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) { /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE11 */
      elem.msRequestFullscreen();
    } else if (elem.webkitEnterFullscreen) { /* iOS */
      elem.webkitEnterFullscreen();
    }
    console.log("onFullscreen")
  }

  // native pause event
  onPause() {
    if (this.isVideoPlayingValue) {
      this.isVideoPlayingValue = false;
      this._stopVideo();
    }
  }

  _handleInfoState() {
    this._startInfoTransition();
    this.infoVisibleValue ? this._showInfo() : this._hideInfo();
  }

  _showInfo() {
    this.element.classList.add('-open');
    this.wrapperTarget.style.display = "block"
    requestAnimationFrame(this._showInfoAnimation.bind(this))
    this._stopVideo();
    this._hidePlayPause();
  }

  _hideInfo() {
    this.element.classList.remove('-open');
    requestAnimationFrame(this._hideInfoAnimation.bind(this))
    this._showPlayPause();
  }

  _showInfoAnimation() {
    gsap.to(this.wrapperTarget, {
      x: "0%",
      duration: 0.5,
      onComplete: this._endInfoTransition.bind(this)
    })
  }

  _hideInfoAnimation() {
    gsap.to(this.wrapperTarget, {
      x: "-100%",
      duration: 0.5,
      onComplete: () => {
        this._endInfoTransition();
        this.wrapperTarget.style.display = "none"
      }
    })
  }

  _startInfoTransition() {
    this.inTransitionValue = true;
    this.element.classList.add('-in-transition');
  }

  _endInfoTransition() {
    this.element.classList.remove('-in-transition');
    this.inTransitionValue = false;
  }

  _startVideo() {
    this.element.classList.add('-video-playing');
    this.videoTarget.play();
    this._hidePlayPause();
    if (this.hasVideoPosterTarget) {
      gsap.to(this.videoPosterTarget, {
        opacity: 0,
        onComplete: () => this.videoPosterTarget.style.display = "none"
      })
    }
    gsap.to(this.infoTarget, {
      x: "-100%"
    })
  }

  _stopVideo() {
    if (this.hasVideoTarget) {
      this.videoTarget.pause();
      this.element.classList.remove('-video-playing');
      gsap.to(this.infoTarget, {
        x: "0"
      })
      this._showPlayPause();
    }
  }

  _mouseMoveDebounced() {
    if (this.isVideoPlayingValue) {
      this._hidePlayPause();
    }
  }

  _showPlayPause() {
    if (this.hasVideoPlayTarget) {
      gsap.to(this.videoPlayTarget, {
        opacity: 1
      })
    }
  }

  _hidePlayPause() {
    if (this.hasVideoPlayTarget) {
      gsap.to(this.videoPlayTarget, {
        opacity: 0
      })
    }
  }

}